import axios from "axios";
import {
  GET_ADMIN_FAILURE,
  GET_ADMIN_REQUEST,
  GET_ADMIN_SECCESS,
  GET_BATCH_FAILURE,
  GET_BATCH_REQUEST,
  GET_BATCH_SUCCESS,
  GET_CATEGORY_FAILURE,
  GET_CATEGORY_REQUEST,
  GET_CATEGORY_SUCCESS,
  GET_SECTION_FAILURE,
  GET_SECTION_REQUEST,
  GET_SECTION_SUCCESS,
  GET_TAG_FAILURE,
  GET_TAG_REQUEST,
  GET_TAG_SUCCESS,
  GET_TYPE_FAILURE,
  GET_TYPE_REQUEST,
  GET_TYPE_SUCCESS,
} from "./actionTypes";

export const getBatch = (token) => (dispatch) => {
  dispatch({
    type: GET_BATCH_REQUEST,
    payload: true,
  })
  return axios.get("http://54.206.125.24:8888/batch/activeBatches")
    .then((r) => {
      dispatch({
        type: GET_BATCH_SUCCESS,
        payload: r.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: GET_BATCH_FAILURE,
        payload: true,
      })
    })
};

export const getSection = (token) => (dispatch) => {
  dispatch({
    type: GET_SECTION_REQUEST,
    payload: true,
  })
  return axios.get("http://54.206.125.24:8888/section/activeSections")
    .then((r) => {
      dispatch({
        type: GET_SECTION_SUCCESS,
        payload: r.data,
      })
    })
    .catch((err) => {
      console.log(err.message);
      dispatch({
        type: GET_SECTION_FAILURE,
        payload: true,
      })
    })
};

export const getType = () => (dispatch) => {
  dispatch({
    type: GET_TYPE_REQUEST,
    payload: true,
  });
  return axios.get("http://54.206.125.24:8888/api/types/")
    .then((res) => {
      dispatch({
        type: GET_TYPE_SUCCESS,
        payload: res.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: GET_TYPE_FAILURE,
        payload: true,
      })
    })
};

export const getTag = () => (dispatch) => {
  dispatch({
    type: GET_TAG_REQUEST,
    payload: true,
  });
  return axios.get("http://54.206.125.24:8888/api/tags/")
    .then((res) => {
      dispatch({
        type: GET_TAG_SUCCESS,
        payload: res.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: GET_TAG_FAILURE,
        payload: true,
      })
    })
};

export const getCategory = () => (dispatch) => {
  dispatch({
    type: GET_CATEGORY_REQUEST,
    payload: true,
  });
  return axios.get("http://54.206.125.24:8888/api/categories/")
    .then((res) => {
      dispatch({
        type: GET_CATEGORY_SUCCESS,
        payload: res.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: GET_CATEGORY_FAILURE,
        payload: true,
      })
    })
};

// -------------creating action for getting all the admins from backend----------------
export const getAdmin = () => (dispatch) => {
  dispatch({
    type: GET_ADMIN_REQUEST,
    payload: true,
  });
  axios.get("http://54.206.125.24:8888/api/users/adminusers")
    .then((res) => {
      dispatch({
        type: GET_ADMIN_SECCESS,
        payload: res.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: GET_ADMIN_FAILURE,
        payload: true,
      })
    })
};
